// extracted by mini-css-extract-plugin
module.exports = {"content":"shopsModal__content--2RHN6","header":"shopsModal__header--2nzjL","subHeading":"shopsModal__subHeading--3Geaf"};